import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { TextButtonUniDriver } from '@wix/design-system/dist/testkit/unidriver';
import { baseUniDriverFactory } from '../../unidriver';

export const SaveToNewViewFooterUniDriver = (
  base: UniDriver,
  body: UniDriver,
) => {
  const footerBase = () => base.$('[data-hook="save-to-new-view-footer"]');
  const saveButton = () =>
    TextButtonUniDriver(base.$('[data-hook="save-to-new-view"]'), body);

  return {
    ...baseUniDriverFactory(base),
    exists: () => footerBase().exists(),
    /** Click the "Save to New View" button */
    clickSaveNewView: () => saveButton().click(),
    /** Get the "Save to New View" TextButton driver */
    getSaveNewViewBtn: () => saveButton(),
  };
};
